import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AdminCtx = createContext();

export function AdminProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  const check = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setAdmin(data.role === "admin" ? data : null);
    } catch { setAdmin(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { check(); }, [check]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.user.role !== "admin") throw new Error("Accès réservé aux administrateurs");
    localStorage.setItem("hs_token", data.token);
    setAdmin(data.user);
  };
  const logout = () => { localStorage.removeItem("hs_token"); setAdmin(null); };

  return <AdminCtx.Provider value={{ admin, loading, login, logout }}>{children}</AdminCtx.Provider>;
}

export const useAdmin = () => useContext(AdminCtx);
